import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn cn() helper — merges Tailwind classes intelligently. Later
// classes win on conflicts so conditional overrides work.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
